import { render, staticRenderFns } from "./VehiclesPage.vue?vue&type=template&id=7a57288b"
import script from "./VehiclesPage.vue?vue&type=script&lang=js"
export * from "./VehiclesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports